import { InfoCircleOutlined } from "@ant-design/icons"

import styles from "./infoNote.module.less"

// A note that explains a panel's figures, as the design draws it: a pale blue box, an outline info
// icon and muted text (DAA-4-12).
const InfoNote = ({ children }) => (
  <div className={styles.place}>
    <div className={styles.note}>
      <InfoCircleOutlined className={styles.icon} />
      <span>{children}</span>
    </div>
  </div>
)

export default InfoNote
